import React, { useEffect, useState } from "react";
import { makeStyles, Container, Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { useQuery } from "@apollo/client";
import { GET_ALL_ARCHIVE_MENU } from "../../../quries/archiveMenu";
import { GET_CONCERT_MENU } from "../../../quries/concert_video";
import ConcertThumbBox from "./ConcertThumbBox";

const useStyles = makeStyles((theme) => ({
  topContainer: {
    paddingTop: "10rem",
    paddingBottom: "6rem",
    [theme.breakpoints.down("xs")]: { paddingTop: "5rem" },
  },
  sidePadding: {
    paddingLeft: "6rem",
    paddingRight: "6rem",
    [theme.breakpoints.down("xs")]: {
      paddingLeft: 32,
      paddingRight: 32,
    },
  },
  bigTitle: {
    fontFamily: "Noto Sans KR",
    fontSize: 64,
    color: "black",
    fontWeight: 900,
    // letterSpacing: -4,
    // display: "inline-block",
    paddingBottom: 32,
    [theme.breakpoints.down("xs")]: {
      fontSize: 32,
      paddingBottom: 16,
    }, // paddingBottom: 8,
  },
}));

interface ConcertContainerProps {
  match: any;
  location: any;
  history: any;
}

function ConcertContainer({ match, location, history }: ConcertContainerProps) {
  const classes = useStyles();
  const theme = useTheme();
  const mdMatches = useMediaQuery(theme.breakpoints.down("md"));

  const { data, loading, error } = useQuery(GET_CONCERT_MENU, {
    fetchPolicy: "no-cache",

    variables: {
      limit: 0,
      sort: "created_at:DESC",
    },
  });

  const [concertMenu, setConcertMenu] = useState<any>(null);

  useEffect(() => {
    if (data && data.concertPrograms) {
      setConcertMenu(data.concertPrograms);
    }
    return () => {
      setConcertMenu(null);
    };
  }, [data]);

  if (loading) return null;
  if (data === undefined) return null;
  if (error || !data.concertPrograms) {
    console.log(error);
  }

  if (concertMenu) {
    return (
      <Container
        maxWidth={false}
        disableGutters
        className={classes.topContainer}
      >
        <Container
          maxWidth={"xl"}
          disableGutters={true}
          className={classes.sidePadding}
        >
          <Grid
            item
            xs={12}
            className={classes.bigTitle}
          >
            노동인권문화제 공연
          </Grid>
          <Grid xs={12} item container>
            {concertMenu.length > 0 ? (
              concertMenu.map((concert: any, index: any) => {
                return (
                  <ConcertThumbBox
                    concertArr={concert}
                    key={`concert-thumbox-${concert.title}-${index}`}
                  />
                );
              })
            ) : (
              <div></div>
            )}
          </Grid>
        </Container>
      </Container>
    );
  } else {
    return <div></div>;
  }
}

// export default MainContainer;
export default ConcertContainer;
